// export const apiBaseURL = process.env.NODE_ENV === 'development'
//     ? 'http://127.0.0.1:8000'
//     : 'https://api.japaanow.com'
export const apiBaseURL = process.env.REACT_APP_API_BASE_URL ?? "http://localhost:8000"
// export const apiBaseURL = 'https://dev.japaanow.com'
export const wsHost = "a1btrxpc1e.execute-api.eu-west-2.amazonaws.com/production/?ignore="
// export const apiBaseURL = 'jfsdijio'